const API_URL = 'https://dieseo-gmbh.jobs.personio.de/search.json';
const APPLY_URL = 'https://dieseo-gmbh.jobs.personio.de/job/';
const ALL_DEPARTMENT_VALUE = 'all';

let initialized = false;
let jobs = [];
let filteredJobs = [];
let activeDepartment = ALL_DEPARTMENT_VALUE;
let searchTerm = '';
let shouldScrollToIframe = false;

async function initJobs() {
	const section = document.getElementById('jobs');
	if (!section || initialized) return;

  initialized = true;

	// DOM
	const listEl = document.getElementById('jobs-list');
	const searchInput = document.getElementById('jobs-search-input');
	const deptFilterEl = document.getElementById('department-filter');
	const emptyState = document.getElementById('jobs-empty');

	const countEl = document.getElementById('jobs-count');
	const locationsEl = document.getElementById('jobs-locations');
	const categoriesEl = document.getElementById('jobs-categories');

	const jobView = document.getElementById('job-view');
	let jobFrame = document.getElementById('personio-iframe');
	const backButton = document.getElementById('back-button');

	const skeletonJobs = document.getElementById('jobs-skeleton');
	const skeletonSummary = document.getElementById('summary-skeleton');
	const skeletonDept = document.getElementById('department-skeleton');

	function showListSkeletons() {
		skeletonJobs.style.display = 'block';
		skeletonSummary.style.display = 'flex';
		skeletonDept.style.display = 'flex';

		listEl.style.display = 'none';
		deptFilterEl.style.display = 'none';
		emptyState.style.display = 'none';
	}

	function hideListSkeletons() {
		skeletonJobs.style.display = 'none';
		skeletonSummary.style.display = 'none';
		skeletonDept.style.display = 'none';
	}

	function showJobListView() {
		jobView.classList.add('visually-hidden');
		document.querySelector('.jobs-container').classList.remove('visually-hidden');
	}

	function showJobDetailView(jobId) {
		document.querySelector('.jobs-container').classList.add('visually-hidden');
		jobView.classList.remove('visually-hidden');

		const jobSkeleton = document.getElementById('job-skeleton');
		jobSkeleton.classList.remove('visually-hidden');
		jobFrame.classList.add('visually-hidden');

		history.pushState({}, '', `?job=${jobId}`);
		renderJobDetail(jobId);
	}

	function replaceJobIframe(src) {
		jobFrame.classList.add('visually-hidden');

		const iframe = document.createElement('iframe');

		iframe.id = jobFrame.id;
		iframe.className = jobFrame.className;
		iframe.src = src;
		iframe.loading = 'eager';
		iframe.allow = 'clipboard-write; fullscreen';
		iframe.style.width = '100%';
		iframe.style.border = '0';

		jobFrame.parentNode.replaceChild(iframe, jobFrame);
		jobFrame = iframe;

		return iframe;
	}


	async function fetchJobs() {
		const res = await fetch(API_URL, {
		headers: {
				'Accept-Language': window?.Shopify?.locale || 'de',
		},
		});
		jobs = await res.json();
		filteredJobs = jobs;
	}

	function updateStats() {
		countEl.textContent = jobs.length;

		const locations = new Set();
		const categories = new Set();

		jobs.forEach((j) => {
		j.department && categories.add(j.department);
		j.offices?.forEach((loc) => locations.add(loc.trim()));
		});

		locationsEl.textContent = locations.size;
		categoriesEl.textContent = categories.size;
	}

	function buildDepartmentFilter() {
		const allBtn = deptFilterEl.querySelector('[data-dept="all"]');
		deptFilterEl.innerHTML = '';
		if (allBtn) deptFilterEl.appendChild(allBtn);

		const deptList = [...new Set(jobs.map(j => j.department).filter(Boolean))].sort();

		deptFilterEl.insertAdjacentHTML(
			'beforeend',
			deptList.map(d => `<button class="dept-tab" data-dept="${d}">${d}</button>`).join('')
		);

		deptFilterEl.addEventListener('click', (e) => {
		const btn = e.target.closest('.dept-tab');
		if (!btn) return;

		deptFilterEl.querySelectorAll('.dept-tab').forEach((b) => b.classList.remove('active'));
		btn.classList.add('active');

		const dept = btn.dataset.dept;
		activeDepartment = dept;
		applyFilters();
		});
	}

	function renderJobList() {
		if (!filteredJobs.length) {
		listEl.style.display = 'none';
		emptyState.style.display = 'block';
		hideListSkeletons();
		return;
		}

		listEl.innerHTML = filteredJobs
		.map(
				(job) => `
		<div class="job-item">
				<div>
				<h3 class="job-title">${job.name}</h3>
				<p class="job-location">${job.offices?.join(', ') || job.office || ''}</p>
				<p class="job-category">${job.department}</p>
				</div>
				<button class="job-btn" data-job-id="${job.id}">
				${listEl.dataset.viewJob}
				</button>
		</div>
		`
		)
		.join('');

		listEl.style.display = 'block';
		deptFilterEl.style.display = 'flex';
		emptyState.style.display = 'none';

		hideListSkeletons();
	}

	function applyFilters() {
		filteredJobs = jobs.filter((j) => {
		const matchesDept = activeDepartment === ALL_DEPARTMENT_VALUE || j.department === activeDepartment;

		const matchesSearch =
				!searchTerm ||
				j.name?.toLowerCase().includes(searchTerm) ||
				j.department?.toLowerCase().includes(searchTerm) ||
				j.office?.toLowerCase().includes(searchTerm);

		return matchesDept && matchesSearch;
		});

		renderJobList();
	}

	function renderJobDetail(jobId) {
		const job = jobs.find((j) => j.id == jobId);

		const summaryEl = document.getElementById('job-summary');
		if (!job || !summaryEl) return;

		const jobSummaryTitleEl = summaryEl.querySelector('.job-summary-title');
		const jobSummaryEmploymentTypeEl = summaryEl.querySelector('.jsb-employment-type');
		const jobSummaryOfficeEl = summaryEl.querySelector('.jsb-office');

		if (jobSummaryTitleEl) jobSummaryTitleEl.textContent = job.name || "";
		if (jobSummaryEmploymentTypeEl) jobSummaryEmploymentTypeEl.textContent = job.employment_type || "";

		if (jobSummaryOfficeEl) jobSummaryOfficeEl.textContent = job.offices?.join(', ') || job.office || "";

		replaceJobIframe(`${APPLY_URL}${jobId}?language=de&display=de`);

		summaryEl.querySelector('.apply-button')?.addEventListener('click', () => {
			const skeleton = document.getElementById('job-skeleton');

			skeleton.classList.remove('visually-hidden');
			replaceJobIframe(`${APPLY_URL}${jobId}?language=de&display=de#apply`);

			shouldScrollToIframe = true;
		});
	}

	listEl.addEventListener('click', (e) => {
		const btn = e.target.closest('.job-btn');
		if (!btn) return;

		showJobDetailView(btn.dataset.jobId);
		window.scrollTo(0, 0);
	});

	backButton.addEventListener('click', () => {
		showJobListView()
		history.replaceState({}, '', window.location.pathname);
	});

	searchInput.addEventListener('input', (e) => {
		searchTerm = e.target.value.toLowerCase().trim();
		applyFilters();
	});

	window.addEventListener('popstate', () => {
		const params = new URLSearchParams(location.search);
		const jobId = params.get('job');

		jobId ? showJobDetailView(jobId) : showJobListView();
	});

	window.addEventListener('message', (e) => {
		if (!Array.isArray(e.data)) return;
		const [event, value] = e.data;

		if (event === 'setHeight') {
			jobFrame.style.height = value + 'px';
			document.getElementById('job-skeleton').classList.add('visually-hidden');
			jobFrame.classList.remove('visually-hidden');
			if (shouldScrollToIframe) {
				const offset = 200;
				const y =
					jobFrame.getBoundingClientRect().top +
					window.pageYOffset +
					offset;

				window.scrollTo({
					top: y,
					behavior: 'smooth',
				});

				shouldScrollToIframe = false;
			}
			else {
				window.scrollTo(0, 0);
			}
		}
	});

	showListSkeletons();
	await fetchJobs();
	updateStats();
	buildDepartmentFilter();
	renderJobList();

	const params = new URLSearchParams(location.search);
	const jobId = params.get('job');
	if (jobId) showJobDetailView(jobId);
}

initJobs();

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('#jobs')) {
    initialized = false;
    initJobs();
  }
});
